import axios from 'axios';
import {
  MY_ACCOUNT_GET_MY_TRANSACTIONS_BEGIN,
  MY_ACCOUNT_GET_MY_TRANSACTIONS_SUCCESS,
  MY_ACCOUNT_GET_MY_TRANSACTIONS_FAILURE,
  MY_ACCOUNT_GET_MY_TRANSACTIONS_DISMISS_ERROR,
} from './constants';
import CommonService from '../../../services/commonService';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getMyTransactions(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: MY_ACCOUNT_GET_MY_TRANSACTIONS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(args.url,{
        headers:CommonService.getHeaders()
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MY_ACCOUNT_GET_MY_TRANSACTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: MY_ACCOUNT_GET_MY_TRANSACTIONS_FAILURE,
            data: { error: err.response },
          });
          reject(err.response);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetMyTransactionsError() {
  return {
    type: MY_ACCOUNT_GET_MY_TRANSACTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MY_ACCOUNT_GET_MY_TRANSACTIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getMyTransactionsPending: true,
        getMyTransactionsError: null,
      };

    case MY_ACCOUNT_GET_MY_TRANSACTIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        getMyTransactionsPending: false,
        getMyTransactionsError: null,
        myTransactions:action.data
      };

    case MY_ACCOUNT_GET_MY_TRANSACTIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        getMyTransactionsPending: false,
        getMyTransactionsError: action.data.error,
      };

    case MY_ACCOUNT_GET_MY_TRANSACTIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getMyTransactionsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/my-account/redux/getMyTransactions.js